import React from "react"
import PropTypes from "prop-types"
import './style.css'
import NRTTable from "../../../../../../components/_common/Table"
import {PaymentMethodsEnum} from "../../../../../../enums/PaymentMethodsEnum";
import Currency from "../../../../../../components/_common/Currency";


const SaleInfo = (props) => {


    const {
        image,
        release,
        buyer,
        payment,
        guests,
    } = props


   // console.log(payment, 'payment ')
    return (
        <div className='nrt-sale-info'>

            <h4>Item escolhido</h4>
            <div className="item-sale">
                <img src={`${image}`}/>
                <p>{release.name}</p>
            </div>

            <h4>Contratante</h4>
            <p>{buyer.cpfCnpj} - {buyer.name}</p>


            <NRTTable
                headers={[
                    {fieldName: 'name'},
                    {fieldName: 'value'}
                ]}

                hideHeaders={true}
                data={(() => {


                    let returnList = []

                    // Desconto
                    if (!!payment.discountValue) {
                        returnList.push({
                            name: "Desconto:",
                            value: `R$ ${payment.discountValue}`
                        })
                    }

                    if (payment.installmentNumber > 1) {

                        // // Entrada
                        // if (!!payment.downPayment) {
                        //     returnList.push({
                        //         name: "Entrada:",
                        //         value: `R$ ${payment.downPayment}`
                        //     })
                        // }

                        // Parcela
                        returnList.push({
                            name: "Parcelas:",
                            value: `${payment.installmentNumber}X de ${payment.installmentValue.toFixed(2)}`
                        })
                    }

                    return returnList

                })()}
            />

            <h4 style={{marginTop:'1.5rem'}}>Participantes</h4>

            <NRTTable
                headers={[
                    {
                        title: 'Nome',
                        fieldName: 'name',
                    },
                    {
                        title: 'Email',
                        fieldName: 'email',
                    }
                ]}

                data={
                    !!guests ?
                        guests
                            .map(guest => ({
                                name: guest.name,
                                email: guest.email
                            })) : []
                }
            />

            <p className={"total_value"}>
                <b>Total:</b>
                <Currency value={ (() => {

                    if (payment.pagSeguro && payment.paymentMethod === PaymentMethodsEnum.CREDIT_CARD.code ) {
                        return payment.saleValue - (payment.discountValue || 0 )
                    }


                    return ((payment.installmentNumber * payment.installmentValue))
                        .toFixed(2)

                })()}/>


            </p>
        </div>
    )

}

SaleInfo.propTypes = {
    image: PropTypes.string.isRequired,
    payment: PropTypes.object.isRequired,
    buyer: PropTypes.object.isRequired,
    release: PropTypes.object.isRequired,
    guests: PropTypes.array.isRequired,
}


export default SaleInfo



// WEBPACK FOOTER //
// ./src/_pages/Sale/_partials/ConfirmationStep/_components/SaleInfo/index.js